import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["width", "height", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import IconBase from '../IconBase';
import { jsx as _jsx } from "react/jsx-runtime";

var Facebook = function Facebook(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(IconBase, _objectSpread(_objectSpread({
    $styles: {
      width: width,
      height: height
    },
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.8962 21.9605C17.9992 21.5073 22 17.2209 22 12.0001C22 6.47727 17.5228 2.00012 12 2.00012C6.47715 2.00012 2 6.47727 2 12.0001C2 16.848 5.44966 20.8901 10.0282 21.8058V14.5881H7.625V11.699H10.0282V9.56754C10.0282 7.09439 11.4801 5.75012 13.6043 5.75012C14.6199 5.75012 15.4925 5.82439 15.75 5.86153V8.4535H14.2766C13.118 8.4535 12.8962 9.01795 12.8962 9.85718V11.699H15.6499L15.2923 14.5881H12.8962V21.9605Z",
      fill: color
    })
  }));
};

export default Facebook;